const DEFAULT_MODEL_NAMES = ['Fast', 'Balanced', 'Smart'] as const;

/**
 * Returns the human-readable label for a model index.
 * Prefers any backend-supplied label before falling back to the default trio.
 */
export function getModelDisplayName(index: number, providedName?: string | null): string {
  if (providedName && providedName.trim().length > 0) {
    return providedName;
  }

  return DEFAULT_MODEL_NAMES[index] ?? `Model ${index + 1}`;
}

export function getDefaultModelNames() {
  return DEFAULT_MODEL_NAMES.slice();
}
